export const truncate = (value: string | number, maxLength = 12, chartsToShow = 4, separator = ' **** ') => {
  const stringToTruncate = `${value}`;

  if (stringToTruncate.length <= maxLength) return stringToTruncate;

  return `${stringToTruncate.substring(0, chartsToShow)}${separator}${stringToTruncate.substring(
    stringToTruncate.length - chartsToShow,
  )}`;
};
